export default "__VITE_ASSET__BRRkedy9__"